import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NetworkErrorService {
  hasNetworkError = signal<boolean>(false);

  showError() {
    this.hasNetworkError.set(true);
  }

  hideError() {
    this.hasNetworkError.set(false);
  }
}
